import { getAllRegisters, getSabtenamHistory } from '@/api/sabtenam'
export default {
    state: {
        registers: {},
        history: []

    },

    mutations: {

        SET_REGISTERS: (state, data) => {
            state.registers = data
        },

        SET_REGISTERS_HISTORY: (state, data) => {
            state.history = data
        },

    },

    actions: {
        getAllRegisters({ commit }) {

            return new Promise((resolve, reject) => {
                getAllRegisters().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    var structure = {}
                    structure['همه موارد'] = [];
                    for (var i = 0; i < data.length; i++) {
                        var register = data[i];
                        if (!structure.hasOwnProperty(register.Category)) {
                            structure[register.Category] = []
                        }

                        structure[register.Category].push(register)
                        structure['همه موارد'].push(register)
                    }

                    commit('SET_REGISTERS', structure)


                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getSabtenamHistory({ commit }) {

            return new Promise((resolve, reject) => {
                getSabtenamHistory().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_REGISTERS_HISTORY', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },


    }
}